import { type FC } from 'react';
import { Button } from '@direct-frontend/components';

type ButtonEditStubProps = {
    children: string;
};

export const ButtonEditStub: FC<ButtonEditStubProps> = ({ children }) => (
    <Button color="contour" size="m" isDisabled>
        {children}
    </Button>
);
